import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from 'containers/Layout/Layout';
import Loader from 'components/Loader/Loader';
import {
  HOME_PAGE,
  LISTING_POSTS_PAGE,
  SINGLE_POST_PAGE,
  PRIVACY_PAGE,
  ABOUT_PAGE,
  TERMS_PAGE,
  BLOG_PAGE,
  BLOG_POST_1,
  BLOG_POST_2,
  ADD_PLACE_PAGE,
} from './settings/constant';

const HomePage = React.lazy(() => import('containers/Home/Home'));
const ListingPage = React.lazy(() => import('containers/Listing/Listing'));
const SinglePageView = React.lazy(() =>
  import('containers/SinglePage/SinglePageView')
);
const PrivacyPage = React.lazy(() => import('containers/Privacy/Privacy'));
const TermsPage = React.lazy(() => import('containers/Terms/Terms'));
const AboutPage = React.lazy(() => import('containers/About/About'));
const BlogPage = React.lazy(() => import('containers/Blogs/Blogs'));
const BlogPost1 = React.lazy(() => import('containers/BlogPost/BlogPost1'));
const BlogPost2 = React.lazy(() => import('containers/BlogPost/BlogPost2'));
const AddPlace = React.lazy(() => import('containers/AddPlace/AddPlace'));
const NotFound = React.lazy(() => import('containers/404/404'));

export default function AppRoutes() {
  return (
    <Routes>
      {/* Standalone page — no header/footer */}
      <Route
        path={ADD_PLACE_PAGE}
        element={
          <React.Suspense fallback={<Loader />}>
            <AddPlace />
          </React.Suspense>
        }
      />

      <Route path={HOME_PAGE} element={<Layout />}>
        <Route
          index
          element={
            <React.Suspense fallback={<Loader />}>
              <HomePage />
            </React.Suspense>
          }
        />
        <Route
          path={LISTING_POSTS_PAGE}
          element={
            <React.Suspense fallback={<Loader />}>
              <ListingPage />
            </React.Suspense>
          }
        />
        <Route
          path={`${SINGLE_POST_PAGE}/:slug`}
          element={
            <React.Suspense fallback={<Loader />}>
              <SinglePageView />
            </React.Suspense>
          }
        />
        <Route
          path={PRIVACY_PAGE}
          element={
            <React.Suspense fallback={<Loader />}>
              <PrivacyPage />
            </React.Suspense>
          }
        />
        <Route
          path={TERMS_PAGE}
          element={
            <React.Suspense fallback={<Loader />}>
              <TermsPage />
            </React.Suspense>
          }
        />
        <Route
          path={ABOUT_PAGE}
          element={
            <React.Suspense fallback={<Loader />}>
              <AboutPage />
            </React.Suspense>
          }
        />
        <Route
          path={BLOG_PAGE}
          element={
            <React.Suspense fallback={<Loader />}>
              <BlogPage />
            </React.Suspense>
          }
        />
        <Route
          path={BLOG_POST_1}
          element={
            <React.Suspense fallback={<Loader />}>
              <BlogPost1 />
            </React.Suspense>
          }
        />
        <Route
          path={BLOG_POST_2}
          element={
            <React.Suspense fallback={<Loader />}>
              <BlogPost2 />
            </React.Suspense>
          }
        />
        <Route
          path="*"
          element={
            <React.Suspense fallback={<Loader />}>
              <NotFound />
            </React.Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
